import { JSONSchemaType } from "ajv"
import validateConstant from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { TTekiseiSindanPostReq, TTekiseiSindanPutReq } from "./TTekiseiSindan"

export const tekiseiSindanRegisterPostReqSchema: JSONSchemaType<TTekiseiSindanPostReq> =
  {
    type: "object",
    properties: {
      乗務員ID: {
        type: "number",
        title: "乗務員ID",
        errorMessage: util.stringErrorMessage("乗務員ID", {
          required: true,
        }),
      },
      適性診断種類区分コード: {
        type: "string",
        minLength: 1,
        title: "適性診断種類",
        errorMessage: util.stringErrorMessage("適性診断種類", {
          required: true,
        }),
      },
      実施機関: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "実施機関",
        errorMessage: util.stringErrorMessage("実施機関", {
          required: true,
        }),
      },
      実施日: {
        type: "string",
        minLength: 1,
        title: "実施日",
        errorMessage: util.stringErrorMessage("実施日", {
          required: true,
        }),
      },
      所見: {
        type: "string",
        title: "所見",
        nullable: true,
        errorMessage: util.stringErrorMessage("所見", {}),
      },
      判定結果1: {
        type: "number",
        title: "判定結果1",
        errorMessage: util.stringErrorMessage("判定結果1", {
          required: true,
        }),
      },
      判定結果2: {
        type: "number",
        title: "判定結果2",
        errorMessage: util.stringErrorMessage("判定結果2", {
          required: true,
        }),
      },
      判定結果3: {
        type: "number",
        title: "判定結果3",
        errorMessage: util.stringErrorMessage("判定結果3", {
          required: true,
        }),
      },
      判定結果4: {
        type: "number",
        title: "判定結果4",
        errorMessage: util.stringErrorMessage("判定結果4", {
          required: true,
        }),
      },
      判定結果5: {
        type: "number",
        title: "判定結果5",
        errorMessage: util.stringErrorMessage("判定結果5", {
          required: true,
        }),
      },
      判定結果6: {
        type: "number",
        title: "判定結果6",
        errorMessage: util.stringErrorMessage("判定結果6", {
          required: true,
        }),
      },
      判定結果7: {
        type: "number",
        title: "判定結果7",
        errorMessage: util.stringErrorMessage("判定結果7", {
          required: true,
        }),
      },
      判定結果8: {
        type: "number",
        title: "判定結果8",
        errorMessage: util.stringErrorMessage("判定結果8", {
          required: true,
        }),
      },
      判定結果9: {
        type: "number",
        title: "判定結果9",
        errorMessage: util.stringErrorMessage("判定結果9", {
          required: true,
        }),
      },
      判定結果10: {
        type: "number",
        title: "判定結果10",
        errorMessage: util.stringErrorMessage("判定結果10", {
          required: true,
        }),
      },
    },
    required: [
      "乗務員ID",
      "適性診断種類区分コード",
      "実施機関",
      "実施日",
      "判定結果1",
      "判定結果2",
      "判定結果3",
      "判定結果4",
      "判定結果5",
      "判定結果6",
      "判定結果7",
      "判定結果8",
      "判定結果9",
      "判定結果10",
    ],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        ["乗務員ID", "乗務員"],
        ["適性診断種類区分コード", "適性診断種類"],
        "実施機関",
        "実施日",
        "判定結果1",
        "判定結果2",
        "判定結果3",
        "判定結果4",
        "判定結果5",
        "判定結果6",
        "判定結果7",
        "判定結果8",
        "判定結果9",
        "判定結果10",
        "所見",
      ]),
    },
  }

export const tekiseiSindanRegisterPutReqSchema: JSONSchemaType<TTekiseiSindanPutReq> =
  {
    type: "object",
    properties: {
      乗務員ID: {
        type: "number",
        title: "乗務員ID",
        errorMessage: util.stringErrorMessage("乗務員ID", {
          required: true,
        }),
      },
      適性診断種類区分コード: {
        type: "string",
        minLength: 1,
        title: "適性診断種類",
        errorMessage: util.stringErrorMessage("適性診断種類", {
          required: true,
        }),
      },
      実施機関: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "実施機関",
        errorMessage: util.stringErrorMessage("実施機関", {
          required: true,
        }),
      },
      実施日: {
        type: "string",
        minLength: 1,
        title: "実施日",
        errorMessage: util.stringErrorMessage("実施日", {
          required: true,
        }),
      },
      所見: {
        type: "string",
        title: "所見",
        nullable: true,
        errorMessage: util.stringErrorMessage("所見", {}),
      },
      判定結果1: {
        type: "number",
        title: "判定結果1",
        errorMessage: util.stringErrorMessage("判定結果1", {
          required: true,
        }),
      },
      判定結果2: {
        type: "number",
        title: "判定結果2",
        errorMessage: util.stringErrorMessage("判定結果2", {
          required: true,
        }),
      },
      判定結果3: {
        type: "number",
        title: "判定結果3",
        errorMessage: util.stringErrorMessage("判定結果3", {
          required: true,
        }),
      },
      判定結果4: {
        type: "number",
        title: "判定結果4",
        errorMessage: util.stringErrorMessage("判定結果4", {
          required: true,
        }),
      },
      判定結果5: {
        type: "number",
        title: "判定結果5",
        errorMessage: util.stringErrorMessage("判定結果5", {
          required: true,
        }),
      },
      判定結果6: {
        type: "number",
        title: "判定結果6",
        errorMessage: util.stringErrorMessage("判定結果6", {
          required: true,
        }),
      },
      判定結果7: {
        type: "number",
        title: "判定結果7",
        errorMessage: util.stringErrorMessage("判定結果7", {
          required: true,
        }),
      },
      判定結果8: {
        type: "number",
        title: "判定結果8",
        errorMessage: util.stringErrorMessage("判定結果8", {
          required: true,
        }),
      },
      判定結果9: {
        type: "number",
        title: "判定結果9",
        errorMessage: util.stringErrorMessage("判定結果9", {
          required: true,
        }),
      },
      判定結果10: {
        type: "number",
        title: "判定結果10",
        errorMessage: util.stringErrorMessage("判定結果10", {
          required: true,
        }),
      },
      更新日時: {
        type: "string",
        minLength: 1,
        title: "更新日時",
        errorMessage: util.stringErrorMessage("更新日時", {
          required: true,
        }),
      },
    },
    required: [
      "乗務員ID",
      "適性診断種類区分コード",
      "実施機関",
      "実施日",
      "判定結果1",
      "判定結果2",
      "判定結果3",
      "判定結果4",
      "判定結果5",
      "判定結果6",
      "判定結果7",
      "判定結果8",
      "判定結果9",
      "判定結果10",
      "更新日時",
    ],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        ["乗務員ID", "乗務員"],
        ["適性診断種類区分コード", "適性診断種類"],
        "実施機関",
        "実施日",
        "判定結果1",
        "判定結果2",
        "判定結果3",
        "判定結果4",
        "判定結果5",
        "判定結果6",
        "判定結果7",
        "判定結果8",
        "判定結果9",
        "判定結果10",
        "所見",
        "更新日時",
      ]),
    },
  }
